import { axiosApiClient } from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/coupons";

class CouponsService {
  createCoupon = async (requestData) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/`, requestData);
      if (response.status !== 201) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while creating coupon.");
    }
  };

  getCoupons = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/`);
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching coupons.");
    }
  };

  checkCoupon = async (code) => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/check/${code}`);
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while checking coupon.");
    }
  };

  updateCoupon = async (id, requestData) => {
    try {
      const response = await axiosApiClient.put(
        `${BASE_URL}/${id}`,
        requestData
      );
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Greška pri izmeni kupona.");
    }
  };

  deleteCoupon = async (id) => {
    try {
      const response = await axiosApiClient.delete(`${BASE_URL}/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while deleting coupon.");
    }
  };
}
const couponsService = new CouponsService();

export default couponsService;
